// extracted by mini-css-extract-plugin
module.exports = {"stat":"_5b10bb2305--stat--He8CB"};